import Vue from "vue";
import Router from "@/router";
let isClickDisabled = false;

const timer = () => {
  return setTimeout(() => {
    isClickDisabled = false;
  }, 1500);
}; // 严

class goRouter {
  // 是否为小程序环境
  constructor() {
    if (window.__wxjs_environment === "miniprogram") {
      this.isWx = true;
    } else {
      this.isWx = false;
    }
  }
  navigateTo(path) {
    if (isClickDisabled) {
      return;
    }
    isClickDisabled = true;
    timer();
    if (this.isWx) {
      Vue.prototype.$wx.miniProgram.navigateTo({
        url: "/pages" + path,
      });
    } else {
      Router.push({
        path: path,
      });
    }
  }
  navigateBack(delta) {
    if (isClickDisabled) {
      return;
    }
    isClickDisabled = true;
    timer();

    if (this.isWx) {
      Vue.prototype.$wx.miniProgram.navigateBack({
        delta: delta ? delta : 1,
      });
    } else {
      Router.go(delta ? delta : -1);
    }
  }
  reLaunch(path) {
    if (isClickDisabled) {
      return;
    }
    isClickDisabled = true;
    timer();

    if (this.isWx) {
      Vue.prototype.$wx.miniProgram.reLaunch({
        url: "/pages" + path,
      });
    } else {
      Router.push({
        path: path,
      });
    }
  }
  redirectTo(path) {
    if (isClickDisabled) {
      return;
    }
    isClickDisabled = true;
    timer();

    if (this.isWx) {
      Vue.prototype.$wx.miniProgram.redirectTo({
        url: "/pages" + path,
      });
    } else {
      Router.push({
        path: path,
      });
    }
  }
}

const MyRouter = new goRouter();
export { MyRouter };
